require('./contractSlider.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
// @ utilities
const { formatAmount, parseSpanishNumberToFloat } = require('utilities/currencyHelper');
const formHelper = require('../../utilities/formHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
// @components
const OKSliderInput = require('commonsComponents/OKSliderInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
//@constants
const { MAX_LABEL, MIN_LABEL } = require('constants/index');

class ContractSlider extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnValueChange = this.handleOnValueChange.bind(this);
    }

    componentDidMount() {
        const { component, contractWizard, localState, updateCardDetails } = this.props;
        const { target } = component;
        const cardDetails = contractWizard.get('card_details');
        const { card_details } = localState;
        const maxApprovedLimit = Number(contractWizard.get('maxLimitToAuthorize')) || null;
        const userSelectedLimit = card_details.find(x => x.id === 'creditLimit')
            ? card_details.find(x => x.id === 'creditLimit').value
            : null;

        if (cardDetails) {
            const sliderTarget = cardDetails.find(x => x.get('id') === target);

            if (sliderTarget && !sliderTarget.get('value')) {
                card_details.find(x => x.id === target).value = component.default_value;
                updateCardDetails(card_details);
            }
        }

        if (
            !!maxApprovedLimit &&
            maxApprovedLimit < component.value &&
            component.value !== parseInt(userSelectedLimit, 10) &&
            !userSelectedLimit
        ) {
            this.handleOnValueChange(maxApprovedLimit);
        }
    }

    buildMinMaxLabels(min_value, max_value, is_money) {
        const minValue = is_money ? formatAmount(min_value, getLanguage(), 0) : min_value;
        const maxValue = is_money ? formatAmount(max_value, getLanguage(), 0) : max_value;

        return {
            minLabel: `${toFirstUppercase(MIN_LABEL)} ${minValue}`,
            maxLabel: `${toFirstUppercase(MAX_LABEL)} ${maxValue}`
        };
    }

    buildMinMaxValues(creditLimitMarks, min_value, max_value, is_money) {
        let minValue = creditLimitMarks ? creditLimitMarks[0] : min_value;
        let maxValue = creditLimitMarks ? creditLimitMarks[creditLimitMarks.length - 1] : max_value;

        if (is_money) {
            minValue = parseInt(minValue);
            maxValue = parseInt(maxValue);
        }

        return {
            minValue,
            maxValue
        };
    }

    handleOnValueChange(data) {
        const { handleOnChange, component } = this.props;
        const value = data.value || data;

        handleOnChange(component, value);
    }

    render() {
        const { component, contractWizard, extraInfo } = this.props;
        const {
            default_value,
            label,
            inputType,
            min_value,
            max_value,
            sliderMarks,
            format_type,
            sliderStep,
            is_money,
        } = component;
        const value = formHelper
            .getCardDetailsElement(component, contractWizard.get('card_details'))
            .get('value');
        const immLimitCreditMarks = contractWizard.get('limitCreditMarks');
        const renderSliderStep = immLimitCreditMarks ? null : sliderStep;
        const creditLimitMarks = immLimitCreditMarks ? immLimitCreditMarks.toJS() : sliderMarks;
        const { minValue, maxValue } = this.buildMinMaxValues(creditLimitMarks, min_value, max_value, is_money);
        const minValueSlider = minValue || 0;
        const maxValueSlider = maxValue || 0;
        const { minLabel, maxLabel } = this.buildMinMaxLabels(minValue, maxValue, is_money);
        let parsedValue = value;
        if (inputType === 'float') {
            parsedValue = parseSpanishNumberToFloat(value);
        }
        let valueSlider = parsedValue < minValue ? minValue : parsedValue;
        valueSlider = valueSlider > maxValue ? maxValue : valueSlider;
        valueSlider = valueSlider || default_value || 0;
        valueSlider = parseFloat(valueSlider);

        let creditLimitMarksInput;
        if (value && creditLimitMarks && !creditLimitMarks.includes(value.toString())) {
            creditLimitMarksInput = creditLimitMarks.slice(0);
            creditLimitMarksInput.push(value.toString());
            creditLimitMarksInput.sort((a, b) => a - b);
        } else {
            creditLimitMarksInput = creditLimitMarks;
        }

        const sliderLabel = formatText(label);
        let toolTip;

        if (extraInfo) {
            toolTip = (
                <OKTooltip
                    content={extraInfo}
                    modifier="dark-bg"
                    offset={[0, -15]}
                    type="custom"
                />
            );
        }

        return (
            <article className="contract-slider">
                <section className="contract-slider__slider-container">
                    <OKSliderInput
                        defaultValue={valueSlider}
                        extraInfo={toolTip}
                        inputType="formatWithDecimal"
                        marks={creditLimitMarks}
                        max={maxValueSlider}
                        maxLabel={maxLabel}
                        min={minValueSlider}
                        minLabel={minLabel}
                        onChange={this.handleOnValueChange}
                        step={renderSliderStep}
                        title={sliderLabel}
                        unit={format_type}
                    />
                </section>
            </article>
        );
    }
}

ContractSlider.propTypes = {
    localState: PropTypes.object.isRequired,
    contractWizard: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    updateCardDetails: PropTypes.func.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    extraInfo: PropTypes.object
};

module.exports = ContractSlider;
